import { render, staticRenderFns } from "./Resa.vue?vue&type=template&id=6951c48c&"
import script from "./Resa.vue?vue&type=script&lang=js&"
export * from "./Resa.vue?vue&type=script&lang=js&"
import style0 from "./Resa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports